var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center"},[_c('span',{staticClass:"font-rubik font-medium text-xs text-icon uppercase mb-2"},[_vm._v("Cost")]),_c('span',{staticClass:"font-nunito font-bold text-4xl text-default"},[_vm._v(" $"+_vm._s(_vm.price.toLocaleString())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }